export type ThemeType = 'light' | 'dark';
export const DEFAULT_THEME = 'dark';
